<template>
  <div>
    <el-table
      @row-click="clickRow" 
      v-loading="loading"
      ref="multipleTable"
      :data="safeTableData"
      :span-method="spanMethod"
      :row-class-name="rowClassName"
      border
      tooltip-effect="dark"
      :style="{marginTop:marginTop}"
      @selection-change="SelectionChange"
      :row-key="getRowKey"
      :highlight-current-row="false"
    >
      <slot name="table"></slot>
    </el-table>

    <div
      style="display: flex; justify-content: flex-end; margin-top: 16px"
      v-if="tableData.length !== 0 "
    >
    <!-- <div style="display: flex; justify-content: flex-end; margin-top: 40px" v-if='tableData.length !== 0 && hideTable == false'> -->

      <el-pagination
        v-if="paginationVisible && safeTotal > 0"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="safeCurrentPage"
        :page-sizes="[10, 15, 20]"
        layout="total, sizes, prev, pager, next"
        class=""
        :total="safeTotal"
        :pager-count="5"
      />
    </div>
  </div>
</template>

<script>
import i18nMixin from '@/mixins/i18nMixin';

export default {
  mixins: [i18nMixin],
  name: "commonTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    hideTable:{ //显隐表单
      type:Boolean,
      default:false
    },
    spanMethod: {
      type: Function,
      default: () => {},
    },
    rowClassName: {
      type: Function,
      default: () => {},
    },
    total: {
      //总条数
      type: Number,
      default: 0,
    },

    currentPage: {
      //当前页数
      type: Number,
      default: 1,
    },

    loading: {
      //表格加载
      type: Boolean,
      default: false,
    },

    handleSizeChange: {
      //监听切换条数
      type: Function,
      default: () => {},
    },

    handleCurrentChange: {
      type: Function,
      default: () => {},
    },

    handleSelectionChange: {
      type: Function,
      default: () => {},
    },
    handleClickRow: {
      type: Function,
      default: () => {},
    },
    paginationVisible:{
       //表格加载
      type: Boolean,
      default: true,
    },
    clearName:{
      type: String,
      default: '',
    },
    itemKey:{
      type: String,
      default: '',
    },
    marginTop:{
      type: String,
      default: '24px',
    },
  },
  data() {
    return {
      computedClearName:[
        'demandProtuctsCheck',
      ]
    };
  },
  computed: {
    // 确保分页组件接收到的值都是有效的
    safeTotal() {
      const total = parseInt(this.total) || 0;
      return total >= 0 ? total : 0;
    },
    safeCurrentPage() {
      const currentPage = parseInt(this.currentPage) || 1;
      return currentPage >= 1 ? currentPage : 1;
    },
    safeTableData() {
      return Array.isArray(this.tableData) ? this.tableData : [];
    }
  },
  methods: {
    /**@method 监听切换条数并调用父组件方法 */
    sizeChange(val) {
      this.$emit("handleSizeChange", val);
      /*  handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      } */
    },
    /**@method 监听下一页并调用父组件方法 */
    currentChange(val) {
      this.$emit("handleCurrentChange", val);
      /* handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
      } */
    },
    SelectionChange(val) {
      if( this.computedClearName.includes(this.clearName)){
        const item = val.find(item =>{return item[this.itemKey] != "0"});
        if(item){
          this.$refs.multipleTable.clearSelection();
          this.$message({
            message: this.$t('business', 'selectAuditDemand'),
            type: "warning",
          });
          return;
        }
      }
      this.$emit("handleSelectionChange", val);
    },
    clickRow(row){
      this.$emit("handleClickRow", row);
    },
    // 获取行的唯一标识
    getRowKey(row) {
      return row.ordersId || row.id;
    },
    // 切换行展开状态
    toggleRowExpansion(row, expanded) {
      this.$refs.multipleTable.toggleRowExpansion(row, expanded);
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
